import React, {useRef} from 'react';
import PropTypes from 'prop-types';
import classNames from "classnames";
import Button from "UI/Button";
import Modal from "UI/Modal";
import {PhotographIcon} from "@heroicons/react/outline";

const classes = {
    modal: classNames(
        'w-full h-full'
    )
};

export default function MediaDetailModal({open, onClose, media}) {
    const initialFocusRef = useRef();

    const backgroundImageStyles = {
        backgroundImage: "url('" + media.filename + "')",
    };

    return <Modal
        open={open}
        onClose={onClose}
        className={classes.modal}
//        initialFocus={initialFocusRef}
    >
        <Modal.Header className="inline-flex items-center bg-indigo-500 text-white">
            <PhotographIcon className='w-5 inline-block mr-2' /> {media.label}
        </Modal.Header>
        <div className='flex flex-grow flex-row'>
            <div className='flex flex-grow bg-black bg-contain bg-center bg-no-repeat' style={backgroundImageStyles} />

            { /*
                <div className=''>
                    Column?
                </div>
            */ }
        </div>
        <Modal.Footer>
            <Button type='plain' onClick={onClose}>Close</Button>
        </Modal.Footer>
    </Modal>;
}

MediaDetailModal.propTypes = {
    open: PropTypes.string.isRequired,
    onClose: PropTypes.string.isRequired,
};

MediaDetailModal.defaultProps = {

};
